import Grid from '@mui/material/Grid';

import { FormInput } from '../../../components/hook-form/form-input.component';
import { rebateCompanyApiKeyStore } from '../../../api/masters/rebate-company-api-key-store';
import { FormAutoCompleteMultiSelectDynamic } from '../../../components/hook-form/form-autocomplete-multi-select.dynamic.component';

export const RebateCompanyForm = () => {
  return (
    <Grid container spacing={2}>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormInput label="Rebate Company Name" name="utilRebateCompanyName" maxLength={150} autoFocus />
      </Grid>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormInput label="Description" name="description" maxLength={150} multiline size={3} />
      </Grid>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormInput type='number' label="Amount" name="amount" />
      </Grid>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormAutoCompleteMultiSelectDynamic
          name="rebateTypes"
          label="Rebate Type"
          getQueryKeyConfig={() => rebateCompanyApiKeyStore.getRebateTypes()}
          optionsLabelKey="utilRebateTypeName"
          optionsValueKey="utilRebateTypeID"
        />
      </Grid>
    </Grid>
  );
};
